import request from '../request';

export const getGroups = () => request({
  url: '/group',
  method: 'GET',
});
